import { t } from 'i18next'
import { InputText } from 'primereact/inputtext'
import React, { useEffect, useState } from 'react'
import { BusinessCard } from './BusinessCard'
import { Company } from '../../../../model/company.model'
import { Apprentice, Person } from '../../../../model/person.model'
import { useAppSelector } from '../../../../redux/hooks'
import { BirthdayBox } from '../../../util/birthday-box/BirthdayBox'

export const BusinessCards = () => {
  const { loadedBasicInformation } = useAppSelector((state) => state.user)
  const apprentices: Apprentice[] = useAppSelector((state) => state.apprentices)
  const employees: Person[] = useAppSelector((state) => state.employees)

  const [searchFilter, setSearchFilter] = useState<string>('')
  const [filteredApprentices, setFilteredApprentices] = useState<Apprentice[]>(
    []
  )
  const [filteredEmployees, setFilteredEmployees] = useState<Person[]>([])

  useEffect(() => {
    if (!loadedBasicInformation) return

    const filterApprentices = apprentices
      .filter((a) => a.is_active === 1)
      .filter(
        (a) =>
          !searchFilter ||
          searchFilter.length === 0 || // Show all if no filter
          a.full_name?.toLowerCase().includes(searchFilter.toLowerCase())
      )
    const filterEmployees = employees
      .filter((e) => e.is_active === 1)
      .filter(
        (e) =>
          !searchFilter ||
          searchFilter.length === 0 || // Show all if no filter
          e.full_name?.toLowerCase().includes(searchFilter.toLowerCase())
      )

    setFilteredApprentices(filterApprentices)
    setFilteredEmployees(filterEmployees)
  }, [
    loadedBasicInformation,
    searchFilter,
    apprentices.length,
    employees.length,
  ])

  const companies: Company[] = useAppSelector((state) => state.companies)

  const getCompanyName = (
    companyId: number | undefined
  ): string | undefined => {
    if (!companyId || !companies) {
      return undefined
    }
    const company = companies.find((c: Company) => c.company_id === companyId)
    return company?.company_name
  }

  return (
    <div className="card">
      <span className="p-input-icon-left mt-1 mb-1">
        <i className="fa-solid fa-filter" />
        <InputText
          value={searchFilter}
          type="search"
          className="business-card-width"
          placeholder={t('core.filter_name')}
          onChange={(e) => setSearchFilter(e.target.value)}
        />
      </span>
      <div
        className="flex flex-wrap dashboard-cards overflow-auto mr-0 pr-0"
        style={{ height: 'calc(100vh - 240px)' }}
      >
        <BirthdayBox />
        {filteredApprentices.map((apprentice: Apprentice) => (
          <div
            key={`app_${apprentice.person_id}`}
            className="flex align-items-start justify-content-start"
          >
            <BusinessCard
              person={apprentice}
              companyName={getCompanyName(apprentice.id_company)}
            />
          </div>
        ))}
        {filteredEmployees.map((employee: Person) => (
          <div
            key={`emp_${employee.person_id}`}
            className="flex align-items-start justify-content-start"
          >
            <BusinessCard
              person={employee}
              companyName={getCompanyName(employee.id_company)}
            />
          </div>
        ))}
      </div>
    </div>
  )
}